import React, {useEffect, useState} from "react";
import {
    Button, Checkbox, Chip, CircularProgress, Icon,
    MenuItem,
    Paper,
    Select,
    Table, TableCell,
    TableContainer,
    TableHead, TableRow,
    TextField,
    Typography
} from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import Dropzone from "react-dropzone";
import {
    MuiPickersUtilsProvider,
    DatePicker
} from '@material-ui/pickers';
import {saveAs} from 'file-saver';
import {generateZip} from "../utilities";
import axios from 'axios';

const SUBMIT_URL = 'https://www.hatchids.com/api/trademark_form/'

const TMForm = () => {
    const [progress, setProgress] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

    const [usingMark, setUsingMark] = useState(false)
    const [date, setDate] = useState(null)
    const [affadavitFiles, setAffadavitFiles] = useState([])  // FILES

    const [markType, setMarkType] = useState('Word Mark')
    const [markText, setMarkText] = useState('')
    const [markFile, setMarkFile] = useState(null)  // FILE

    const [description, setDescription] = useState('')
    const [attorneyFile, setAttorneyFile] = useState(null)  // FILE

    const [additional, setAdditional] = useState('')

    const handleAffadavitFilesDrop = (files) => {
        setAffadavitFiles(affadavitFiles.concat(files))
    }
    const handleAffadavitFileRemove = (target_index) => {
        setAffadavitFiles(affadavitFiles.filter((file, index) => index !== target_index));
    }


    const downloadAffadavitFile = async () => {
        const res = await fetch("files/AffidavitForUserClaim.docx");
        const blob = await res.blob()
        console.log(blob)
        saveAs(blob, "Template_User Affidavit.docx");
    }
    const downloadAffadavitSample = async () => {
        const res = await fetch("files/SampleAffadavitForUserClaim.pdf");
        const blob = await res.blob()
        console.log(blob)
        saveAs(blob, "Sample_Executed User Affidavit.pdf");
    }
    const downloadPOA = async () => {
        const res = await fetch("files/POA.doc");
        const blob = await res.blob()
        console.log(blob)
        saveAs(blob, "POA.doc");
    }

    const handleFormSubmit = async () => {
        setProgress(true)
        let files = affadavitFiles || []
        if (markFile !== null) {
            files = files.concat(markFile)
        }
        if (attorneyFile !== null) {
            files = files.concat(attorneyFile)
        }
        const uploaded_files_zip = await generateZip(files, "FILES.zip");

        const formData = new FormData()
        formData.append('name', name);
        formData.append('email', email);
        formData.append('address', address);
        formData.append('phone', phone);
        formData.append('markText', markText);
        formData.append('usedDate', date || '');
        formData.append('description', description);
        formData.append('additional', additional);
        if (uploaded_files_zip) {
            formData.append('file', uploaded_files_zip);
        }


        axios.post(SUBMIT_URL, formData)
            .then(res => {
                console.log('SUCCESS')
                setProgress(false)
                setSubmitted(true)
                resetForm()
            }).catch(err => {
            console.log(err)
            setProgress(false)
        })

    }

    const resetForm = () => {
        setName('');
        setEmail('')
        setProgress(false)
        setAddress('')
        setPhone('')
        setAffadavitFiles([])
        setAttorneyFile(null)
        setMarkFile(null)
        setMarkText('')
        setDescription('')
        setAdditional('')

        setTimeout(() => {
            setSubmitted(false);

        }, 20000)
    }

    useEffect(() => {
    }, [name, email, phone, address, description, markText, date])

    useEffect(
        () => {
            console.log(date)
        }, [date]
    )

    return (
        <div>

            <div className='max-w-2xl mx-auto'>
                <Typography
                    className='text-xl text-20'
                            style={{fontSize: 24, paddingTop: 24, paddingBottom: 12, paddingLeft: 24}}>
                    Trademark Requisition Form
                </Typography>
                <Paper className='m-4 mb-8 flex flex-col paper'>
                    <Chip label='Applicant Details'
                          color={"primary"}
                          className='-mt-6 self-start mb-4 bg-gray-100'
                          size={"small"}/>
                    <TextField
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        variant='outlined'
                        label='Applicant Name*'
                        style={{marginBottom: 12}}
                        className='w-full max-w-md rounded-none mb-12'
                        placeholder='Applicant Name'
                        InputLabelProps={{
                            shrink: true,
                        }}/>
                    <TextField
                        variant='outlined'
                        label='Applicant Address'
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        style={{marginBottom: 12}}
                        className='w-full max-w-md rounded-none mb-12'
                        placeholder='Applicant Address'
                        InputLabelProps={{
                            shrink: true,
                        }}/>
                    <TextField
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        variant='outlined'
                        label='Email Address*'
                        style={{marginBottom: 12}}
                        className='w-full max-w-md rounded-none mb-default'
                        placeholder='Email Address'
                        InputLabelProps={{
                            shrink: true,
                        }}/>
                    <TextField
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        variant='outlined'
                        label='Phone No.'
                        className='w-full max-w-md rounded-none'
                        placeholder='Phone No.'
                        InputLabelProps={{
                            shrink: true,
                        }}/>
                </Paper>
                <Paper className='m-4 mb-8 shadow-md flex flex-col paper'>
                    <Chip label='Mark Details'
                          color={"primary"}
                          className='-mt-6 self-start mb-4 bg-gray-100'
                          size={"small"}/>

                    <div>
                        <Select
                            value={markType}
                            onChange={(event) => setMarkType(event.target.value)}
                            className='text-14 bg-white mr-4 my-4'
                        >

                            <MenuItem value="Word Mark">Word Mark</MenuItem>
                            <MenuItem value="Logo/Device Mark">Logo/Device Mark</MenuItem>
                        </Select>
                        {markType === 'Word Mark' && (
                            <TextField
                                value={markText}
                                onChange={(e) => setMarkText(e.target.value)}
                                variant='outlined'
                                label='Word Mark'
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                className='w-full max-w-sm rounded-none'
                                placeholder='Please enter the work mark here'/>
                        )}
                    </div>
                    {markType === 'Logo/Device Mark' && (
                        <div className='mt-4'>
                            <Dropzone
                                onDropRejected={() => window.alert("Something went wrong")}
                                onDrop={(files) => setMarkFile(files[0])}
                                multiple={false}
                                accept=".pdf,.png,.jpg,.jpeg"

                            >
                                {({getRootProps, getInputProps}) => (
                                    <section
                                        className='cursor-pointer border border-dashed rounded-lg h-128 border-gray-500 bg-gray-100  hover:bg-gray-300 hover:border-gray-700 p-4'>
                                        <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <p className='text-center align-middle'>Drag 'n' drop Logo/Device Mark
                                                here, or
                                                click to
                                                select file.
                                            </p>
                                            <p className='text-center align-middle'>
                                                Please upload an image file such as .jpg or .png or .pdf
                                            </p>
                                        </div>
                                    </section>
                                )}
                            </Dropzone>
                            {markFile && (
                                <TableContainer component={Paper}
                                                className='rounded-none mt-4 paper max-w-md'>
                                    <Table size={"small"} aria-label="a table">
                                        <TableRow>
                                            <TableCell>{markFile.name}</TableCell>
                                            <TableCell><Icon onClick={() => setMarkFile(null)}
                                                             className='text-red-light cursor-pointer'>x</Icon></TableCell>
                                        </TableRow>
                                    </Table>
                                </TableContainer>
                            )}
                        </div>

                    )}
                    <TextField
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        variant='outlined'
                        label='Description of the goods/services'
                        className='w-full rounded-none mb-4'
                        style={{marginTop: 12}}
                        placeholder='Please enter description of goods/services for which the mark is intended to be used'
                        multiline
                        maxRows={4}
                        minRows={4}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                </Paper>
                <Paper className='m-4 mb-8 shadow-md flex flex-col paper'>
                    <Chip label='Use Details'
                          color={"primary"}
                          className='-mt-6 self-start mb-4 bg-gray-100'
                          size={"small"}/>
                    <div>

                        <div className='flex flex-row items-center'>
                            <Checkbox value={usingMark} onChange={(e)=>setUsingMark(e.target.checked)}/><Typography>Are you already using the mark? (Leave it unchecked if the mark is Proposed to be used)</Typography>
                        </div>
                        {/*<Select*/}
                        {/*    value={dateType}*/}
                        {/*    onChange={(event) => setDateType(event.target.value)}*/}
                        {/*    className='text-14 bg-white mr-4 my-4'*/}
                        {/*>*/}

                        {/*    <MenuItem value="Is the Mark Proposed to be Used?">Is the Mark Proposed to be*/}
                        {/*        Used?</MenuItem>*/}
                        {/*    <MenuItem value="Are you already using the mark?">Are you already using the*/}
                        {/*        mark?</MenuItem>*/}
                        {/*</Select>*/}
                    </div>
                    {usingMark && (
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>

                            <DatePicker
                                label="Specify date, since when the mark being used"
                                animateYearScrolling
                                // disableFuture
                                value={date}
                                onChange={setDate}
                                format="dd-MM-yyyy"
                                // clearable
                                // minDate='2020-01-01'
                                variant='outlined'
                            />
                        </MuiPickersUtilsProvider>
                    )}

                    {usingMark  && (
                        <div style={{marginTop: 12}}>
                            <Typography>
                            <span className='cursor-pointer'
                                  style={{color: '#a95216'}}
                                  color={'primary'}
                                  onClick={downloadAffadavitFile}>Download User Affidavit Template</span> | Please Complete, Execute, and Upload the Used Affidavit Below </Typography>
                            <Typography>
                                (See a Sample Executed User
                                Affidavit <span className='cursor-pointer'
                                                style={{color: '#a95216'}}
                                                onClick={downloadAffadavitSample}>Here</span>)
                            </Typography>
                            <div className='mt-8'>
                                <p className='mb-4'>
                                    Upload Use Evidences (Invoices, Advertisement Material, Brochures, Catalogs, and
                                    the
                                    like)
                                </p>
                                <Dropzone
                                    onDropRejected={() => window.alert("Something went wrong")}
                                    onDrop={handleAffadavitFilesDrop}
                                    accept=".pdf,.docx,.doc,.zip"

                                >
                                    {({getRootProps, getInputProps}) => (
                                        <section
                                            className='border cursor-pointer border-dashed rounded-lg h-128 border-gray-500 bg-gray-50 p-4 hover:bg-gray-300 hover:border-gray-700'>
                                            <div {...getRootProps()}>
                                                <input {...getInputProps()} />

                                                <p className='text-center align-middle'>
                                                    One or Multiple at a time. Drag 'n' drop file here, or click to Select File(s)
                                                </p>
                                                <p className='text-center align-middle italic'>Please Upload Evidence of Use for Each Year of Use.</p>
                                            </div>
                                        </section>
                                    )}
                                </Dropzone>
                            </div>

                        </div>
                    )}

                    <TableContainer component={Paper} hidden={affadavitFiles.length <= 0}
                                    className='rounded-none mt-4 paper max-w-md'>
                        <Table size={"small"} aria-label="a table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>S.No.</TableCell>
                                    <TableCell>Filename</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            {
                                affadavitFiles.map((file, index) => (
                                    <TableRow>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{file.name}</TableCell>
                                        <TableCell><Icon onClick={() => handleAffadavitFileRemove(index)}
                                                         className='text-red-light cursor-pointer'>x</Icon></TableCell>
                                    </TableRow>
                                ))
                            }

                        </Table>
                    </TableContainer>

                </Paper>
                <Paper className='m-4 mb-8 shadow-md flex flex-col paper'>
                    <Chip label='Power of Attorney'
                          color={"primary"}
                          className='-mt-6 self-start mb-4 bg-gray-100'
                          size={"small"}/>
                    <Typography
                        onClick={downloadPOA}
                        component={'a'} color={"primary"} className='cursor-pointer'>Download
                        Power of Attorney
                        template</Typography>
                    <div className='mt-4 mb-4'>
                        <Typography
                            component={'a'}>

                            Upload Power of Attorney</Typography>
                        <Dropzone
                            multiple={false}
                            onDropRejected={() => window.alert("Something went wrong")}
                            onDrop={(files) => setAttorneyFile(files[0])}
                            accept=".pdf,.docx,.doc,.zip"
                        >
                            {({getRootProps, getInputProps}) => (
                                <section
                                    className='mt-2 border cursor-pointer border-dashed rounded-lg h-128 border-gray-500 bg-gray-50 hover:bg-gray-300 hover:border-gray-700 p-4'>
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <p className='text-center align-middle'>Drag 'n' drop Power of Attorney file
                                            here,
                                            or
                                            click to
                                            select file</p>
                                    </div>
                                </section>
                            )}
                        </Dropzone>
                        {attorneyFile && (
                            <TableContainer component={Paper}
                                            className='rounded-none mt-4 paper max-w-md'>
                                <Table size={"small"} aria-label="a table">
                                    <TableRow>
                                        <TableCell>{attorneyFile.name}</TableCell>
                                        <TableCell><Icon onClick={() => setAttorneyFile(null)}
                                                         className='text-red-light cursor-pointer'>x</Icon></TableCell>
                                    </TableRow>
                                </Table>
                            </TableContainer>

                        )}

                    </div>
                    <TextField
                        value={additional}
                        onChange={(e) => setAdditional(e.target.value)}
                        variant='outlined'
                        label='Additional details'
                        className='w-full rounded-none mb-4'
                        style={{marginTop: 12}}
                        placeholder='Please enter any additional detail/comment that you may like to share, if any'
                        multiline
                        maxRows={4}
                        minRows={4}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                    {submitted && <Paper className='paper p-4 my-4' style={{background: '#dcffea'}}>
                        <Typography>We thank you for the submission. We'll revert back within 24 hours on the Trade Mark Filing Details.</Typography>
                    </Paper>
                    }
                    <Button
                        disabled={
                            name === '' ||
                            email === '' ||
                            progress
                        }
                        onClick={handleFormSubmit}
                        variant={"contained"}
                        color={"primary"}
                        style={{marginTop:12}}
                        className='mx-auto self-center mt-8'>
                        {progress && <CircularProgress size={24} className='mr-4'/>}
                        Submit</Button>

                </Paper>


            </div>

        </div>
    )
}

export default TMForm;

// Please enter the work mark here
//